// extracted by mini-css-extract-plugin
module.exports = {"row":"BillRow_row__34cDP","orderLink":"BillRow_orderLink__19fPi"};